import { default as enJson } from "./en.json";
import { enPrivacy, enTos } from "./en-legal";
import { default as jaJson } from "./ja.json";
import { jaPrivacy, jaTos } from "./ja-legal";
import { I18nDictationary, I18nMessages, mergeI18nMsgs } from "@joyz/app-core/plugins/jz-i18n";
import { LS_KEY_USER_LANG } from "@tt-app/constants/user";

const en: I18nMessages = (enJson as unknown) as I18nMessages;
const ja: I18nMessages = (jaJson as unknown) as I18nMessages;

export const i18nDictionary: I18nDictationary = {
  en: mergeI18nMsgs(en, enTos, enPrivacy),
  ja: mergeI18nMsgs(ja, jaTos, jaPrivacy)
};

/**
 * @returns language for content and interface
 */
export const getLanguage = (): string => {
  const langInLocalStorage = localStorage.getItem(LS_KEY_USER_LANG);
  return langInLocalStorage !== null ? langInLocalStorage : "ja";
};
